"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.issueDebitNoteRequestSchema = exports.issueCreditNoteRequestSchema = exports.releaseCreditHoldRequestSchema = exports.placeCreditHoldRequestSchema = exports.arAgeingQuerySchema = exports.arOutstandingQuerySchema = exports.arLedgerQuerySchema = exports.resolveOverpaymentRequestSchema = exports.allocateReceiptAutomaticallyRequestSchema = exports.allocateReceiptRequestSchema = exports.cancelInvoiceRequestSchema = exports.writeOffInvoiceRequestSchema = exports.createInvoiceRequestSchema = void 0;
/**
 * Request contracts for Accounts Receivable (Stage 13, Milestone 2
 * Part 1) — `InvoiceApplicationService`/`ReceiptAllocationApplicationService`/
 * `ArLedgerApplicationService`/`CreditHoldApplicationService`
 * (`backend/src/modules/financial/application/`).
 */
const zod_1 = require("zod");
const financial_common_request_1 = require("./financial-common.request");
const invoiceDocumentTypeSchema = zod_1.z.enum(['OPD', 'IPD', 'LAB', 'PHARMACY', 'CORPORATE', 'INSURANCE']);
const createInvoiceLineSchema = zod_1.z.object({
    chargeId: zod_1.z.string().uuid().optional(),
    description: zod_1.z.string().min(1).max(255),
    grossAmount: zod_1.z.number().int().nonnegative(),
    discountAmount: zod_1.z.number().int().nonnegative().optional(),
    taxAmount: zod_1.z.number().int().nonnegative().optional(),
    netAmount: zod_1.z.number().int().nonnegative(),
    /**
     * ECM Phase 7 — resolution provenance, copied verbatim from what
     * `POST /charge-masters/resolve-rates` (or `computeChargeBilling`) returned
     * for this line. Persisted, never recomputed here.
     *
     * Optional on purpose. A line that genuinely was not priced through ECM — a
     * manual line, an adjustment — must leave these unset, because "no
     * provenance" is precisely the signal the Rate Resolution Bypass report
     * looks for. Filling them in speculatively would hide the thing they exist
     * to reveal.
     */
    rateType: zod_1.z.string().max(30).optional(),
    rateSource: zod_1.z.string().max(40).optional(),
    priceVersionId: zod_1.z.string().uuid().optional(),
});
exports.createInvoiceRequestSchema = zod_1.z.object({
    branchId: zod_1.z.string().uuid(),
    hospitalId: zod_1.z.string().uuid().optional(),
    documentType: invoiceDocumentTypeSchema,
    patientId: zod_1.z.string().uuid(),
    payerId: zod_1.z.string().uuid().optional(),
    invoiceDate: zod_1.z.coerce.date(),
    dueDate: zod_1.z.coerce.date().optional(),
    lines: zod_1.z.array(createInvoiceLineSchema).min(1),
    ...financial_common_request_1.financialWorkflowExtrasShape,
});
exports.writeOffInvoiceRequestSchema = zod_1.z.object({
    reason: zod_1.z.string().min(1),
    ...financial_common_request_1.financialWorkflowExtrasShape,
});
exports.cancelInvoiceRequestSchema = zod_1.z.object({
    reason: zod_1.z.string().optional(),
    ...financial_common_request_1.financialWorkflowExtrasShape,
});
exports.allocateReceiptRequestSchema = zod_1.z.object({
    paymentId: zod_1.z.string().uuid(),
    invoiceId: zod_1.z.string().uuid(),
    amount: zod_1.z.number().int().positive(),
    remarks: zod_1.z.string().optional(),
    ...financial_common_request_1.financialWorkflowExtrasShape,
});
exports.allocateReceiptAutomaticallyRequestSchema = zod_1.z.object({
    paymentId: zod_1.z.string().uuid(),
    patientId: zod_1.z.string().uuid(),
    ...financial_common_request_1.financialWorkflowExtrasShape,
});
exports.resolveOverpaymentRequestSchema = zod_1.z.object({
    ...financial_common_request_1.financialWorkflowExtrasShape,
});
exports.arLedgerQuerySchema = zod_1.z.object({
    payerId: zod_1.z.string().uuid().optional(),
    patientId: zod_1.z.string().uuid().optional(),
    from: zod_1.z.coerce.date().optional(),
    to: zod_1.z.coerce.date().optional(),
});
exports.arOutstandingQuerySchema = zod_1.z.object({
    payerId: zod_1.z.string().uuid().optional(),
    patientId: zod_1.z.string().uuid().optional(),
    branchId: zod_1.z.string().uuid().optional(),
});
exports.arAgeingQuerySchema = zod_1.z.object({
    asOfDate: zod_1.z.coerce.date().optional(),
    branchId: zod_1.z.string().uuid().optional(),
});
exports.placeCreditHoldRequestSchema = zod_1.z.object({
    payerId: zod_1.z.string().uuid(),
    reason: zod_1.z.string().min(1),
    ...financial_common_request_1.financialWorkflowExtrasShape,
});
exports.releaseCreditHoldRequestSchema = zod_1.z.object({
    ...financial_common_request_1.financialWorkflowExtrasShape,
});
exports.issueCreditNoteRequestSchema = zod_1.z.object({
    branchId: zod_1.z.string().uuid(),
    patientId: zod_1.z.string().uuid().optional(),
    amount: zod_1.z.number().int().positive(),
    paymentModeId: zod_1.z.string().uuid(),
    reason: zod_1.z.string().min(1),
    invoiceId: zod_1.z.string().uuid().optional(),
    ...financial_common_request_1.financialWorkflowExtrasShape,
});
exports.issueDebitNoteRequestSchema = exports.issueCreditNoteRequestSchema;
//# sourceMappingURL=financial-receivable.request.js.map